import { PayrollCustomFieldDefinition } from 'api/gql-utils/employeeDataSettings/types';
import { EffectiveAccess } from './types';

// Mirrors x-payroll-hris internal/modules/hris/customfields/service/role_policy.go:
// admin always EDIT; empty policy map -> EDIT; absent role -> HIDDEN.
export const getEffectiveAccess = (
  definition: PayrollCustomFieldDefinition,
  roleId: number | string | null | undefined,
  isAdmin: boolean,
): EffectiveAccess => {
  if (isAdmin) return 'EDIT';
  const policy = definition.accessPolicy;
  if (!policy || Object.keys(policy).length === 0) return 'EDIT';
  if (roleId === null || roleId === undefined) return 'HIDDEN';
  const raw = (policy as Record<string, string>)[String(roleId)];
  if (raw === 'EDIT') return 'EDIT';
  if (raw === 'VIEW' || raw === 'VIEW_ONLY') return 'VIEW';
  return 'HIDDEN';
};
